import "./contact.css";
import { Button } from "@mui/material";

export default function Contact() {
  return (
    <>
      <div className="contact-form">
        <h1 id="contact-title">Contact</h1>

        <div className="form-container">
          <form>
            <label>Name</label>
            <input type=""></input>

            <label>Mail</label>
            <input type=""></input>

            <label>Message</label>
            <textarea>Some text...</textarea>

            <Button variant="outlined" id="send-button">
              Send
            </Button>
          </form>
        </div>
      </div>
    </>
  );
}
